import { Divider } from '@mui/material';

import { useAppSelector } from 'state/hooks';
import { selectCurrentScenarioId } from 'state/workflowSlice';

import { PROCESS_STATUS, ScenarioSetupUIMode } from 'appConstants';
import { TaskBarSkeleton } from 'features/task_bar/TaskBar';

import { selectScenarioStatus } from '../../state/detourSlices';
import { selectScenarioSetupUIMode } from '../../state/workflowSlice';
import { DetourMetricsOption } from './DetourTaskBar/DetourMetricsOption';
import { DetourTaskBar } from './DetourTaskBar/DetourTaskBar';

import styles from './Detour.module.css';

export default function DetourSidebar() {
  const uiMode = useAppSelector(selectScenarioSetupUIMode);
  const currentScenarioId = useAppSelector(selectCurrentScenarioId);
  const scenarioStatus = useAppSelector(selectScenarioStatus);
  const open =
    currentScenarioId !== undefined || uiMode === ScenarioSetupUIMode.Create;

  const sidebarClasses = [
    styles.detour_sidebar,
    uiMode === ScenarioSetupUIMode.Scenarios && styles.detour_sidebar_scroll,
    !open && styles.detour_sidebar_hidden,
  ].filter(Boolean) as string[];

  return (
    <TaskBarSkeleton
      ignoreHideSidebar
      classes={sidebarClasses}
      renderSectionFiller={false}
      upper={<DetourTaskBar />}
      middle={null}
      lower={
        scenarioStatus === PROCESS_STATUS.DONE &&
        uiMode === ScenarioSetupUIMode.Scenarios && (
          <>
            <Divider />
            <DetourMetricsOption />
          </>
        )
      }
      lowerClassName="detour_lower"
    />
  );
}
